<template>
    <div class="placeholder activityPage">
        <div class="back" v-if="terminal != 5" @click="back">
            <img src="../../assets/activity_back.png" alt="">
        </div>
        <div class="pic">
            <img src="../../assets/activity_bj2.png" alt="">
        </div>

        <!-- 活动结束或未开启 -->
        <div class="expectation">
            <div class="title">活动未开启 敬请期待！</div>
            <img src="../../assets/activity_overage1.png" class="coverage">
            <div class="get">后续赛事开始将会开启通知</div>
            <div class="confirm" @click="back">确定</div>
        </div>

        <!-- <div class="box_list">
            <div class="box" @click="toggleBox('lottie1')">
                <div style="width: 100px;height: 100px;" id="lottie_box1"></div>
            </div>
            
            <button @click="startFun">播放</button>   
            <button @click="suspendFun">暂停</button>  
        </div> -->
    </div>   
</template>

<script>
// import lottie from 'lottie-web';

export default {
    data(){
        return {
            terminal: null, // 访问来源
        }
    },
    mounted() {
        this.terminal = this.$route.query.terminal

        // this.init()
    },
    methods: {
        init() {
            this.lottie1 = lottie.loadAnimation({
                container: document.getElementById('lottie_box1'),
                renderer: 'svg',
                autoplay: false,
                loop: false,
                path: 'https://oss.dayulong.cn/mini/nodata.json'
            })
        },
        toggleBox(name) {
            this[name].stop();
            this[name].play();
        },
        suspendFun() {
            this.lottie.pause();
        },
        startFun() {
            this.lottie.play()
        },
        back(){
            if(this.terminal == 5){
                uni.switchTab({
                    url: '/pages/index/index'
                })
            } else {
                DYL.backWebView()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../css/activity.scss';
.placeholder {
    .title {
        color: #FFFFFF;
        font-size: 26px;
    }
    .expectation {
        position: absolute;
        z-index: 1;
        text-align: center;
        top: 45vw;
        width: 100%;
    }
    .coverage {
        width: 69.3vw;
        height: 65.7vw;
        margin: 30px 0;
    }
}
</style>
